import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Products from "@/pages/public/Products";
import ProductDetail from "@/pages/public/ProductDetail";
import LocateUs from "@/pages/public/LocateUs";
import FindDistributor from "@/pages/public/FindDistributor";
import MachineLocations from "@/pages/public/MachineLocations";
import Gallery from "@/pages/public/Gallery";
import Contact from "@/pages/public/Contact";

import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Sliders from "@/pages/admin/Sliders";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import Distributors from "@/pages/admin/Distributors";
import MachineLocationsAdmin from "@/pages/admin/MachineLocationsAdmin";
import Testimonials from "@/pages/admin/Testimonials";
import Enquiries from "@/pages/admin/Enquiries";
import Settings from "@/pages/admin/Settings";

function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => {
    window.__lenis = lenis;
  }, [lenis]);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
        <LenisBridge />
        <AuthProvider>
          <SiteProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                <Route element={<PublicLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:slug" element={<ProductDetail />} />
                  <Route path="/locate-us" element={<LocateUs />} />
                  <Route path="/find-distributor" element={<FindDistributor />} />
                  <Route path="/machine-locations" element={<MachineLocations />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/contact" element={<Contact />} />
                </Route>

                <Route path="/admin/login" element={<Login />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Dashboard />} />
                  <Route path="sliders" element={<Sliders />} />
                  <Route path="products" element={<ProductsAdmin />} />
                  <Route path="gallery" element={<GalleryAdmin />} />
                  <Route path="distributors" element={<Distributors />} />
                  <Route path="machine-locations" element={<MachineLocationsAdmin />} />
                  <Route path="testimonials" element={<Testimonials />} />
                  <Route path="enquiries" element={<Enquiries />} />
                  <Route path="settings" element={<Settings />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </SiteProvider>
        </AuthProvider>
        <Toaster position="top-center" richColors />
      </ReactLenis>
    </div>
  );
}

export default App;
